import React from 'react'
import { Link } from 'react-router-dom'
import { useCart } from 'lib/core/hooks'
import { TotalsTable } from '../TotalsTable'
import { Container } from './styled'

export const Totals = () => {
  const { cart } = useCart()

  if (!cart?.data?.prices) {
    return null
  }

  return (
    <Container>
      <p>
        <span>Order Summary</span> <Link to='/cart'>Edit Cart</Link>
      </p>
      <TotalsTable />
    </Container>
  )
}
